import { createReducer, on } from '@ngrx/store';

import * as navActions from './navigation.actions';
import { INavigationState } from './navigation.model';

export const initialState: INavigationState = {
  navItems: [],
  favorites: [],
  isLoading: false,
  shouldHide: false
};

export const navigationReducer = createReducer(
  initialState,
  on(navActions.getNavItems, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(navActions.getNavItemsSuccess, (state, { navItems }) => ({
    ...state,
    navItems,
    isLoading: false,
  })),
  on(navActions.addFavorite, (state, { favorite }) => ({
    ...state,
    favorites: [...(state?.favorites || []), favorite],
  })),
  on(navActions.addFavoriteFailure, (state, { favorite }) => ({
    ...state,
    favorites: [...((state?.favorites || []).filter(fav => fav.navigationId !== favorite.navigationId))],
  })),
  on(navActions.deleteFavorite, (state, { favorite }) => ({
    ...state,
    favorites: [...((state?.favorites || []).filter((fav) => fav.navigationId !== favorite.navigationId ))],
  })),
  on(navActions.deleteFavoriteFailure, (state, { favorite }) => ({
    ...state,
    favorites: [...(state?.favorites || []), favorite],
  })),
  on(navActions.updateFavorites, (state, { newFavorites }) => ({
    ...state,
    favorites: [...newFavorites],
  })),
  on(navActions.updateFavoritesFailure, (state, { oldFavorites }) => ({
    ...state,
    favorites: [...oldFavorites],
  })),
  on(navActions.getNavFavoritesSuccess, (state, { favorites }) => ({
    ...state,
    favorites: [...(state?.favorites || []), ...favorites]
  })),
  on(navActions.getNavFavoritesFailure, (state) => ({
    ...state,
    favorites: [...(state?.favorites || [])]
  })),
  on(navActions.hideNavigation, (state, { shouldHide }) => ({
    ...state,
    shouldHide
  })),
);
